import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import GeneralAlert from "../../components/common/GeneralAlert";
import { Text } from "../../types/text";
import useTextLogic from "../../hooks/logic/textLogic";

interface TextPageWrapperProps {
  Component: React.FC<{
    systemLanguageType: Text["system_language_type"];
  }>;
}

const TextPageWrapper: React.FC<TextPageWrapperProps> = ({ Component }) => {
  const navigate = useNavigate();
  const { system_language_type } = useParams<{
    system_language_type?: string;
  }>();
  const { systemLanguageType } = useTextLogic(system_language_type);

  if (!systemLanguageType) {
    return (
      <GeneralAlert
        errorMessage="Invalid system language type"
        action={() => navigate(-1)}
        actionLabel="Go Back"
      />
    );
  }

  return <Component systemLanguageType={systemLanguageType} />;
};

export default TextPageWrapper;
